import type { UserOrganization } from "@/features/auth/types/authTypes";

export type AnswerForm = "full" | "direct";

type OrganizationFlags =
  | Pick<
      UserOrganization,
      "answer_form_menu_enabled" | "answer_form_slash_enabled"
    >
  | null
  | undefined;

export const isAnswerFormMenuEnabled = (
  organization: OrganizationFlags
): boolean => organization?.answer_form_menu_enabled === true;

export const isAnswerFormSlashEnabled = (
  organization: OrganizationFlags
): boolean => organization?.answer_form_slash_enabled === true;

export const shouldOpenSlashMenu = ({
  menuEnabled,
  slashEnabled,
  inputEmpty,
  key,
}: {
  menuEnabled: boolean;
  slashEnabled: boolean;
  inputEmpty: boolean;
  key: string;
}): boolean => menuEnabled && slashEnabled && inputEmpty && key === "/";

export const buildStreamAnswerForm = ({
  menuEnabled,
  chip,
}: {
  menuEnabled: boolean;
  chip: AnswerForm | null | undefined;
}): AnswerForm | undefined => (menuEnabled && chip ? chip : undefined);
